import api from "../security/api";

const viewRequirementsFindAll = (client, instance) => {
    return api
        .get(`requirements/findAll?client=${client}&instance=${instance}`);
};

const requirementsService = {
    viewRequirementsFindAll
};


export default requirementsService;
